import { createAsyncThunk } from '@reduxjs/toolkit';

import { MyInvestmentsService } from 'api';

import { downloadDocuments } from 'utils';

import { PaginationParams } from 'models';

export const downloadFinishedInvestments = createAsyncThunk(
	'myInvestments/downloadFinishedInvestments',
	(params: PaginationParams) =>
		downloadDocuments(params, `investments.xlsx`, MyInvestmentsService.downloadFinished),
);
